module.exports =
{

  splitter:
  {

    _init: function ()
    {

      APPLICATION._APPLICATION.processLinks('#visits', 'AbortiveVisit', 'abortiveVisits')

    }

  },

  update:
  {

    _init: function ()
    {

        $('#modal-coins_development_id').not('.js-ignore').change(function ()
        {
          $('#update-splitter-modal-development-form-group').removeClass('has-error')
          $('#update-splitter-modal-development-error').css("display", "none")

          var coins_development_id = $(this).val()
          
          var distribution_node = $('#modal-distribution_node_id')
  
          var target = $('#modal-distribution_node_id').data(APPLICATION._DATA_PREFIX + 'target');
          $(target).html('');

          if ('' === coins_development_id)
          {
            distribution_node.next('.dropdown-menu').html('')
          }
  
          else
          {
            $('#modal-box').prepend('<div class="overlay"><div class="spinner-outer"><span class="fa fa-spinner fa-spin spinner"></span></div></div>')
            APPLICATION._APPLICATION.loadDropdown(distribution_node, 
              APPLICATION._PATH_PREFIX + 'installation/splitter-dropdown/' + coins_development_id + '?distribution_node_id=' + distribution_node.val(), 
              'Installation', 
              'splitterDropdown', 
              () => {
                $('#modal-box').find('.overlay').remove()
                
              })
          }
        }
        ).addClass('js-ignore').trigger('change')

        $('#modal-distribution_node_id').not('.js-ignore').change(function ()
        {
            $('#update-splitter-modal-splitter-form-group').removeClass('has-error')
            $('#update-splitter-modal-splitter-error').css("display", "none")
            var distribution_node_id = $(this).val()
            var coins_development_id = $('#modal-coins_development_id').val()
            var target = $('#modal-distribution_node_id').data(APPLICATION._DATA_PREFIX + 'target');

            if(distribution_node_id && coins_development_id){
              $('#modal-box').prepend('<div class="overlay"><div class="spinner-outer"><span class="fa fa-spinner fa-spin spinner"></span></div></div>')
                $.post(APPLICATION._PATH_PREFIX + 'installation/plot-checkboxes/' + coins_development_id + '/' + distribution_node_id,
                {
                
                }
                , function (response)
                {
                    $('#modal-box').find('.overlay').remove();
                    $(target).html(response)
                
                }
                )
            }
        }
        ).addClass('js-ignore').trigger('change')

        $("#update-splitter-button").on("click", (e) => {
            e.preventDefault()
           
            var distribution_node_id = $('#modal-distribution_node_id').val()
            var coins_development_id = $('#modal-coins_development_id').val()

            if(distribution_node_id && distribution_node_id !=0 && coins_development_id && coins_development_id != 0) // check for both fields
            {
              var form_data = $("#update-splitter-form").serialize()
              APPLICATION._noClickOff = false

              // Hide modal
              $('body').removeClass('show-modal')

              // Scroll to the top
              window.scroll(0, 0)

              $.post(APPLICATION._PATH_PREFIX + 'installation/update-splitter/', form_data, () => {
                $("#installation_contractor_submit")?.trigger('click')
                $("#installation_engineer_submit")?.trigger('click')
              })
              
            }
            else{
              if(!coins_development_id || coins_development_id == 0){ //
                $('#update-splitter-modal-development-form-group').addClass('has-error')
                $('#update-splitter-modal-development-error').css("display", "block")
              }
              if(!distribution_node_id || distribution_node_id == 0){
                $('#update-splitter-modal-splitter-form-group').addClass('has-error')
                $('#update-splitter-modal-splitter-error').css("display", "block")
              }
            } 
            

        })

        $('#cancel-update-splitter-button').on("click", () => {
          $('#cancel-update-splitter-modal-body-footer').css("display", "block")
          $('#update-splitter-modal-body-footer').css("display", "none")

        })
        $('#go-back-update-splitter-button').on("click", () => {
          $('#cancel-update-splitter-modal-body-footer').css("display", "none")
          $('#update-splitter-modal-body-footer').css("display", "block")

        })

    }

  }

}